import { render } from "./order-tabel.vue?vue&type=template&id=2e3cadb1&scoped=true"
import script from "./order-tabel.vue?vue&type=script&lang=js"
export * from "./order-tabel.vue?vue&type=script&lang=js"

import "./order-tabel.vue?vue&type=style&index=0&id=2e3cadb1&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e3cadb1"]])

export default __exports__